/*global search_GUID, fakeSearchGUID, fakeRedirect, fakeCarId  */

var menu = {
    init: function() {
        menu.action();
        menu.language();
        menu.currency();
        menu.phones();
    },
    action: function() {
        $('.navigation-link').on('click', function(e) {
            const handler = $(this);
            const navigationLink = $('.navigation-link');
            const block = handler.data('block');
            const link = handler.data('link');

            if (!handler.hasClass('action')) {
                e.preventDefault();
                e.stopPropagation();
            }

            $('.header ,.' + block + ', .' + link).toggleClass('active');
            $('.navigation-block').not('.' + block).removeClass('active');
            navigationLink.not('.' + link).removeClass('active');
        });

        $('.navigation-block').on('click', function(e) {
            e.stopPropagation();
        });

        $('.shorthand').on('click', function(e) {
            e.preventDefault();
            var block = $(this).data('block');

            $('html, body').animate({
                    scrollTop: 0
                }, 700
            ).promise().then(function() {
                $('.navigation-link.' + block).trigger('click');

                if (block === 'my-booking') {
                    $('#my-booking-number').focus();
                }
            });
        });

        $('.open-my-booking').on('click', function(e) {
            e.preventDefault();
            $('.navigation-link.my-booking').trigger('click');
        });
    },
    language: function() {
        $('.language-item').on('click', function(e) {
            if ($(this).data('car-or-partners-page')) { return; }
            e.preventDefault();

            var code = $(this).data('iso-code'),
                currentLang = _d.s.language,
                urlPathname = window.location.pathname,
                search = window.location.search,
                hash = window.location.hash,
                pathname = '';

            $('.language-processing').addClass('active');

            if (urlPathname.indexOf('/' + currentLang) === 0) {
                pathname  = urlPathname.replace('/' + currentLang,  '/' + code) + search;
            } else {
                pathname = '/' + code + window.location.pathname + search;
            }

            window.location = window.location.origin + pathname.replace('/' + _d.s.defaultLanguage + '/', '/') + hash;
        });
    },
    currency: function() {
        $('.currency-item').on('click', function(e) {
            e.preventDefault();
            e.stopPropagation();

            var selected = $(this).data('currency'),
                postData = {currency: selected},
                changeCurrencyUrl = _d.url.portal.setCurrency;

            if ($(this).hasClass('current')) {
                $('.navigation-block, .navigation-link').removeClass('active');
                return false;
            }

            $('.currency-processing').addClass('active');

            if (typeof fakeRedirect !== 'undefined' && fakeRedirect) {
                postData = {
                    currency: selected,
                    GUID: search_GUID,
                    searchGUID: fakeSearchGUID,
                    carId: fakeCarId
                };
            }

            $.post(changeCurrencyUrl, postData, function(response) {
                $('#currentCurrency').html(selected);

                if (typeof fakeRedirect !== 'undefined' && fakeRedirect) {
                    document.location = response.searchUrl;
                } else {
                    document.location.reload();
                }
            });
        });
    },
    phones: function() {
        $('body').on('change', '.all-numbers', function() {
            var option = $(this).find(':selected');

            $('.selected-country-number:visible').html(option.data('phone-number'));
        });
    }
};
